(() => {
  if (customElements.get('mp-delivery')) return;
  class MPDelivery extends HTMLElement {
    connectedCallback() { this.update(); this.timer = setInterval(() => this.update(), 60000); }
    disconnectedCallback() { clearInterval(this.timer); }
    update() {
      const min = Number(this.dataset.min), max = Number(this.dataset.max);
      if (!Number.isInteger(min) || !Number.isInteger(max) || min < 0 || max < min || max > 60) { this.hidden = true; return; }
      const exclusions = new Set((this.dataset.holidays || '').split(',').map(s => s.trim()));
      const key = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      const eligible = d => !(this.dataset.business === 'true' && [0,6].includes(d.getDay())) && !exclusions.has(key(d));
      const offset = days => {
        const d = new Date(); d.setHours(12,0,0,0);
        let count = 0, guard = 0;
        while (count < days && guard++ < 730) { d.setDate(d.getDate()+1); if (eligible(d)) count++; }
        while (!eligible(d) && guard++ < 730) d.setDate(d.getDate()+1);
        return guard >= 730 ? null : d;
      };
      const start = offset(min), end = offset(max);
      if (!start || !end) { this.hidden = true; return; }
      const locale = this.dataset.locale || 'en';
      const format = d => {
        if (locale.startsWith('en')) {
          const day = d.getDate(), mod = day % 100;
          const suffix = mod >= 11 && mod <= 13 ? 'th' : ({1:'st',2:'nd',3:'rd'}[day % 10] || 'th');
          return `${d.toLocaleDateString('en-US',{weekday:'long'})}, ${d.toLocaleDateString('en-US',{month:'long'})} ${day}${suffix}${d.getFullYear() !== new Date().getFullYear() ? ', '+d.getFullYear() : ''}`;
        }
        return d.toLocaleDateString(locale,{weekday:'long',month:'long',day:'numeric',year:d.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined});
      };
      this.querySelector('[data-delivery-start]').textContent = format(start);
      this.querySelector('[data-delivery-end]').textContent = format(end);
      this.hidden = false;
    }
  }
  customElements.define('mp-delivery', MPDelivery);
})();